<template>
  <UserDetail />
</template>

<script>
import UserDetail from '../../../components/dadban/user/index.vue'
import appConfig from '@/app.config'

export default {
  page: {
    title: 'جزئیات کاربر',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    UserDetail,
  },
}
</script>

<style scoped lang="scss"></style>
